<template>
  <div class="_page_float_buttons">
    <!-- <a class="_msg" href="javascript:;" @click.stop="iconOperate1()">
            <b>客服</b>
        </a> -->
    <a
      class="_xcx"
      href="javascript:;"
      @mouseover.stop="iconOperate4()"
      @mouseleave.stop="iconOperate5()"
    >
      <b>小程序</b>
    </a>
    <transition name="fade">
      <div
        class="_page_float_buttons_target"
        v-if="dialogXcxShow"
        style="bottom:62px;"
      >
        <img src="../../static/images/dynamic/wx_xcx_ma.jpg" />
        <b>进入微信小程序</b>
        <i></i>
      </div>
    </transition>
    <a
      class="_crt"
      href="javascript:;"
      @mouseover.stop="iconOperate2()"
      @mouseleave.stop="iconOperate3()"
    >
      <b>APP</b>
    </a>
    <transition name="fade">
      <div
        class="_page_float_buttons_target"
        v-if="dialogEwmShow"
      >
        <img
          v-if="ewmType===1"
          src="../../static/images/dynamic/website_base.png"
        />
        <img
          v-if="ewmType===2"
          src="../../static/images/dynamic/website_prod.png"
        />
        <img
          v-if="ewmType===3"
          src="../../static/images/dynamic/website_normal.png"
        />
        <b>扫描下载斑马APP</b>
        <i></i>
      </div>
    </transition>
    <a
      class="_rep"
      href="javascript:;"
      @click.stop="iconOperate0()"
      v-if="isLoginPage===1"
    >
      <b>工具</b>
    </a>
    <p
      v-if="isLoginPage===1 && show_repair_tips"
      class="_repair_tips"
    >
      <i
        class="_iii_1"
        @click="showRepairTips()"
      >&times;</i>
      登录有问题,点我!
      <i class="_iii_2 fa fa-caret-right"></i>
    </p>
  </div>
</template>

<script>
let dataObj = {
  requestUrl: websiteConfig.commonRequestUrl,
  token: getLocalStorage(websiteConfig.tokenStringName),
  accountBaseInfo: websiteConfig.commonUserInfo,
  isLoginPage: 0,
  show_repair_tips: true,
  ewmType: 1,
  dialogEwmShow: false,
  dialogXcxShow: false
};
export default {
  data() {
    return dataObj
  },
  methods: {
    iconOperate0() {
      let url = window.location.href.indexOf("?r") > 0 ? window.location.href.split("?r")[0] : window.location.href;
      let rUrl = url + "?r=" + parseInt(Math.random() * 99999999);
      window.location.href = rUrl;
    },
    showRepairTips() {
      let _this = this;
      _this.show_repair_tips = false;
    },
    iconOperate1() {
      let _this = this;
      let requestUrl = _this.requestUrl + "/buried/clickCustomerService";
      $.ajax({
        type: "GET",
        url: requestUrl,
        beforeSend: function (request) {
          request.setRequestHeader("token", _this.token);
        },
        success: function (data) {
          console.log(data);
        },
        error: function (error) {
          console.log(error);
        }
      });
      ysf.config({
        "uid": _this.accountBaseInfo.userId,
        "data": JSON.stringify([
          { "key": "real_name", "value": _this.accountBaseInfo.mobile },
          { "key": "mobile_phone", "value": _this.accountBaseInfo.mobile },
          { "key": "email", "value": "admin@keking.cn", "hidden": true },
          { "index": 0, "key": "origin", "label": "", "value": "" }
        ])
      });
      $("#YSF-BTN-HOLDER").click();
    },
    iconOperate2() {
      this.dialogEwmShow = true;
    },
    iconOperate3() {
      this.dialogEwmShow = false;
    },
    iconOperate4() {
      this.dialogXcxShow = true;
    },
    iconOperate5() {
      this.dialogXcxShow = false;
    }
  },
  created() {
    let _this = this;
  },
  mounted() {
    let _this = this;
    let locationUrl = window.location.href;
    let isLogin = locationUrl.indexOf("login.html") >= 0;
    let base = locationUrl.indexOf("uat.keking") >= 0 && locationUrl.indexOf("website-base") >= 0;
    let prod = locationUrl.indexOf("uat.keking") >= 0 && locationUrl.indexOf("website-prod") >= 0;
    let normal = locationUrl.indexOf("i.keking") >= 0;
    if (isLogin) {
      _this.isLoginPage = 1;
    }
    if (base) {
      _this.ewmType = 1;
    }
    if (prod) {
      _this.ewmType = 2;
    }
    if (normal) {
      _this.ewmType = 3;
    }
  }
}
</script>

<style>
._page_float_buttons {
  position: fixed;
  right: 20px;
  bottom: 65px;
  z-index: 1;
}
._page_float_buttons > a {
  display: block;
  width: 45px;
  height: 45px;
  text-align: center;
  margin-bottom: 10px;
  border-radius: 6px;
  background-color: #fff;
  background-position: center 5px;
  background-repeat: no-repeat;
  background-size: auto 60%;
  box-shadow: 0px 0px 13px 0px rgba(47, 129, 232, 0.18);
  position: relative;
}
._page_float_buttons > a._rep {
  background-size: auto 50%;
  background-image: url("../../static/images/repair_icon_n.svg");
}
._page_float_buttons > a._msg {
  background-image: url("../../static/images/chart_icon_n.svg");
}
._page_float_buttons > a._crt {
  background-size: auto 55%;
  background-image: url("../../static/images/down_app_icon_n.svg");
}
._page_float_buttons > a._xcx {
  background-size: auto 50%;
  background-image: url("../../static/images/xiaochengxu_n.png");
}
._page_float_buttons > a:hover {
  background-color: #2f81e8;
}
._page_float_buttons > a:hover._rep {
  background-image: url("../../static/images/repair_icon_s.svg");
}
._page_float_buttons > a:hover._msg {
  background-image: url("../../static/images/chart_icon_s.svg");
}
._page_float_buttons > a:hover._crt {
  background-image: url("../../static/images/down_app_icon_s.svg");
}
._page_float_buttons > a:hover._xcx {
  background-image: url("../../static/images/xiaochengxu_s.png");
}
._page_float_buttons > a > b {
  display: block;
  width: 100%;
  text-align: center;
  color: #666;
  font-size: 1.2rem;
  font-weight: normal;
  position: absolute;
  left: 0px;
  bottom: 2px;
}
._page_float_buttons > a:hover > i,
._page_float_buttons > a:hover > b {
  color: #fff;
}
._page_float_buttons_target {
  display: block;
  width: 130px;
  padding-top: 13px;
  text-align: center;
  border: solid 1px #2f81e8;
  background-color: #fff;
  position: absolute;
  right: 52px;
  bottom: 5px;
  z-index: 2222;
}
._page_float_buttons_target > img {
  display: block;
  width: 80%;
  margin: 0 auto;
}
._page_float_buttons_target > b {
  display: block;
  width: 100%;
  padding-bottom: 10px;
  text-align: center;
  font-weight: normal;
  font-size: 1.2rem;
}
._page_float_buttons_target > i {
  display: inline-block;
  width: 6px;
  height: 11px;
  background: url("../../static/images/ewm_arrow_1.png") no-repeat center center;
  position: absolute;
  left: 130px;
  bottom: 20px;
}
._repair_tips {
  height: 36px;
  line-height: 36px;
  color: #fff;
  border-radius: 6px;
  font-size: 1.4rem;
  white-space: nowrap;
  word-break: keep-all;
  padding: 0px 15px 0px 35px;
  background: url("../../static/images/login_frame_bg.png") repeat left top;
  position: absolute;
  right: 54px;
  bottom: 14px;
  z-index: 1111;
}
._repair_tips > i._iii_1 {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 18px;
  text-align: center;
  border-radius: 10px;
  color: #aaa;
  font-size: 1.8rem;
  background-color: #fff;
  cursor: pointer;
  position: absolute;
  left: 10px;
  top: 8px;
}
._repair_tips > i._iii_2 {
  display: inline-block;
  color: #ccc;
  font-size: 1.8rem;
  position: absolute;
  right: -6px;
  top: 8px;
}
/**********/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/component/public/PageFloatButtons.vue